export const environment = {
  production: true,
  buildId: '3458660314822171',
  configFile: 'config.json',
};
